<template>
    <b-form-input
        :state="state"
        :value="value"
        :placeholder="
            $t('strategy.onepage.horizons.description', {
                index: `${index}`,
            })
        "
        @input="$emit('update:value', $event)"
    />
</template>
<script>
export default {
    props: {
        index: {
            type: String | Number,
            required: true,
        },
        value: {
            type: String | null,
            required: true,
        },
        state: {
            type: Boolean | null,
            required: true,
        },
    },
}
</script>
